import React from 'react';
import { useForm } from 'react-hook-form';
import styled from 'styled-components';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { useTranslation } from 'react-i18next';
import { Redirect } from 'react-router-dom';
import { Colors, Images } from '../themes';
import AuthActions from '../redux/AuthRedux';
import { useSelector, useDispatch } from 'react-redux';

const StyledTextField = styled(TextField)`
  & .MuiInputBase-input,
  .MuiFormLabel-root,
  .MuiFormLabel-root.Mui-focused {
    color: ${Colors.blackText};
  }
  & .MuiFormLabel-root {
    font-style: italic;
    font-size: 16px;
  }
  & .MuiInputLabel-shrink {
    font-style: normal;
    font-size: 13px;
  }
`;

const StyledBody = styled.div`
  background: url(${Images.backgroundBlurred});
  background-size: cover;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
`;

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    [theme.breakpoints.down('lg')]: {
      paddingLeft: 25,
      paddingRight: 25,
    },
  },
  paper: {
    padding: 30,
    paddingTop: 60,
    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: Colors.white,
    borderRadius: 8,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(12),
  },
  logo: {
    width: 155,
  },
  submit: {
    margin: theme.spacing(8, 0, 4),
    color: Colors.white,
    background: Colors.blue,
    '&:hover': {
      background: Colors.lightBlue,
    },
  },
}));

export default function LoginContainer(props) {
  const { register, handleSubmit } = useForm();
  const dispatch = useDispatch();
  const onSubmit = (data) => {
    dispatch(AuthActions.loginRequest(data.username, data.password));
  };
  const error = useSelector((state) => state.auth.errorMessage);
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const redirectToSecureLogin = useSelector((state) => state.auth.redirectToSecureLogin);
  const classes = useStyles();
  const { t } = useTranslation();

  return isAuthenticated ? (
    <Redirect to="/" />
  ) : redirectToSecureLogin ? (
    <Redirect to="/secure-login" />
  ) : (
    <StyledBody>
      <Container component="main" maxWidth="sm" className={classes.container}>
        <CssBaseline />
        <div className={classes.paper}>
          <img src={Images.digiovi} alt="Digiovi" className={classes.logo} />
          <form className={classes.form} noValidate onSubmit={handleSubmit(onSubmit)}>
            <StyledTextField
              error={Boolean(error)}
              margin="normal"
              fullWidth
              id="username"
              label={t('auth.username')}
              name="username"
              autoComplete="username"
              autoFocus
              {...register("username")}
            />
            <StyledTextField
              error={Boolean(error)}
              margin="normal"
              fullWidth
              name="password"
              label={t('auth.password')}
              type="password"
              id="password"
              autoComplete="current-password"
              {...register("password")}
            />
            <Button type="submit" fullWidth variant="contained" color="inherit" className={classes.submit}>
              {t('auth.login')}
            </Button>
          </form>
        </div>
      </Container>
    </StyledBody>
  );
}
